import type { Market } from "@/lib/useMarket"

// The market the panel opens on: the URL's market on a /m/<market> page, else
// the market remembered from the last market page, else none.
export function initialMarket(pageMarket?: Market | null, remembered?: Market | null): Market | null {
  return pageMarket ?? remembered ?? null
}

export type PanelView = "pick_market" | "failed" | "loading" | "ready"

// What the panel body shows. With no market the market list shows and
// nothing is fetched until one is picked.
export function panelView(
  market: Market | null,
  load: { loading: boolean; failed: boolean; ready: boolean },
): PanelView {
  if (market === null) return "pick_market"
  if (load.failed) return "failed"
  if (load.loading || !load.ready) return "loading"
  return "ready"
}
